import { APIURL } from './../constant/apiConstant'
import ApiService from './apiRequest'
import AsyncStorageFunc from '../utilities/asyncStorage';
import {jwtDecode} from "jwt-decode"
import axios from 'axios';

export const sendOtp = params => { return ApiService.post(APIURL.SEND_OTP, params);}
export const getEncKey = params => {return ApiService.get(APIURL.GET_ENC_KEY, params);}

export const login = async (params) => {
  let deviceId = await AsyncStorageFunc.getData('deviceId');
  const loginHeader = {
    deviceModel: "",
    appVersion: "",
    platform: "FF_PORTAL",
    network: "",
    deviceId: deviceId,
    fcmToken: "",
    // "Access-Control-Allow-Origin": "*",
    e_platform: "web",
    loginAuthType:"2.0",
    keepMeSignIn: params?.keepMeSignIn || "N" // Use provided value, default to "N"
  }
  return ApiService.post(APIURL.LOGIN, params, loginHeader)
}
export const validateLoginVrnOTP = async (params) => {
  let deviceId = await AsyncStorageFunc.getData('deviceId');
  const loginHeader = {
    deviceModel: "",
    appVersion: "",
    platform: "FF_PORTAL",
    network: "",
    deviceId: deviceId,
    fcmToken: "",
    // "Access-Control-Allow-Origin": "*",
    e_platform: "web",
    keepMeSignIn: params?.keepMeSignIn || "N" // Use provided value, default to "N"
  }
  return ApiService.post(APIURL.VALIDATELOGINVRNOTP, params, loginHeader)
}
export const forceLogin = async (params) => {
  let deviceId = await AsyncStorageFunc.getData('deviceId');
  const loginHeader = {
    deviceModel: "",
    appVersion: "",
    platform: "FF_PORTAL",
    network: "",
    deviceId: deviceId,
    fcmToken: "",
    // "Access-Control-Allow-Origin": "*",
    e_platform: "web",
    keepMeSignIn: params?.keepMeSignIn || "N" // Use provided value, default to "N"
  }
  return ApiService.post(APIURL.FORCE_LOGIN, params, loginHeader)
}
export const validateOtp = async (params) => {
  let deviceId = await AsyncStorageFunc.getData('deviceId');
  const loginHeader = {
    deviceModel: "", appVersion: "",  platform: "FF_PORTAL", network: "",
    deviceId: deviceId, fcmToken: "",
    // "Access-Control-Allow-Origin": "*",
     e_platform: "web",
     keepMeSignIn: params?.keepMeSignIn || "N" // Use provided value, default to "N"
    }
  if (params?.type == "updateProfile")
    return ApiService.postwithtoken(APIURL.VALIDATE_OTP_APPLYNOW, params)
  else if (params?.type === "login")
    return ApiService.post(APIURL.VALIDATE_OTP, params,loginHeader)
  else if (params?.type === "loginByOTP")
    return ApiService.post(APIURL.VALIDATE_OTP_LOGIN, params,loginHeader)
    else
    return ApiService.post(APIURL.VALIDATE_OTP_APPLYNOW, params)

};
export const validateOtpWithToken_ = params => { return ApiService.postWithToken(APIURL.VALIDATE_OTP_APPLYNOW, params)};
export const checkTagBalance = params => { return ApiService.post(APIURL.WALLET_BAL, params)}
export const resetPassword = params => { return ApiService.post(APIURL.FORGOT_PSWD, params)}
export const getVehicleList = params => { return ApiService.getWithToken(APIURL.GET_ALL_VEHICLES_FOR_USER)}
export const getDashFastags = params => { return ApiService.getWithToken(APIURL.GET_DASHBOARD_FASTAGS)}
export const getExpenseStatsByDate = params => { return ApiService.postwithtoken(APIURL.EXPENSE_STATS_BY_DATE, params)}
export const getPoolAccountdetails = params => { return ApiService.getWithToken(APIURL.GET_POOL_ACCOUNT_DETAILS)}
export const enableAutoPay = params => { return ApiService.getWithToken(APIURL.ENABLE_AUTOPAY_POOL_ACCOUNT)}
export const disableAutoPay = params => { return ApiService.getWithToken(APIURL.DISABLE_AUTOPAY_POOL_ACCOUNT)}
export const getPoolToTag = params => { return ApiService.getWithToken(APIURL.GET_POOL_TO_TAG)}
export const getTagToPool = params => { return ApiService.getWithToken(APIURL.GET_TAG_TO_POOL)}
export const postTagToTagReq = params => {return ApiService.getWithToken(APIURL.POST_TAG_TO_TAG_REQ)}
export const postTagToTagProc = params => {return ApiService.getWithToken(APIURL.POST_TAG_TO_TAG_PROC)}
export const getProfileDetails = params => {return ApiService.getWithToken(APIURL.GET_PROFILE_DETAILS)}
export const getCorporateUserDetails = params => { return ApiService.getWithToken(APIURL.GET_CORPORATE_USER_DETAILS)}
export const getVehicleDetailsByTxnId = async params => {
  let deviceId = await AsyncStorageFunc.getData('deviceId');
  let token = await AsyncStorageFunc.getData('TOKEN');
  const header = { deviceModel: "", appVersion: "", platform: "", network: "", Authorization: token ? "bearer " + token : "", vrn: params, deviceId: deviceId};
  return ApiService.getWithToken(APIURL.GET_VEHICLE_BY_TXN_ID, params, header)
}
export const searchVehicle = params => { return ApiService.postwithtoken(APIURL.SEARCH_VEHICLE, params, undefined)}
export const getProfileImage = params => { return ApiService.getWithToken(APIURL.GET_PROFILE_IMAGE, params, undefined)}
export const uploadProfileImage = params => { return ApiService.postwithtoken(APIURL.UPDATE_PROFILE_IMAGE, params, undefined)}
export const getVehicleClasses = async params => {
  let deviceId = await AsyncStorageFunc.getData('deviceId');
  const header = { deviceId: deviceId };
  return ApiService.get(APIURL.GET_VEHICLE_CLASS, params, header)
}
export const isCommVeh = params => { return ApiService.postwithtoken(APIURL.IS_COMM_VEH, params)}
export const verifyDoc = params => { return ApiService.postwithtoken(APIURL.VERIFY_ENC, params)}
export const getOffers = params => { return ApiService.getWithToken(APIURL.GET_OFFERS, {})}

export const isCommVehcle = params => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.IS_COMM_VEH, params)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err);});
  });
};

export const priceBreakUp = async params => {
  let token = await AsyncStorageFunc.getData('TOKEN');
  let deviceId = await AsyncStorageFunc.getData('deviceId');
  return new Promise((resolve, reject) => {
    const header = {deviceModel: "",appVersion: "",platform: "",network: "",
      Authorization: token ? "bearer " + token : "", deviceId: deviceId, userId: token ? jwtDecode(token).mappedOrgId : ""
    };
    ApiService.postwithtoken(APIURL.PRICE_BREAKUP, params, undefined, header)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err);});
  });
};
export const sendOtpApi = async params => {
  let deviceId = await AsyncStorageFunc.getData('deviceId');
  let token = await AsyncStorageFunc.getData("TOKEN");
  return new Promise((resolve, reject) => {
    const header = {deviceModel: "",appVersion: "", platform: "",network: "",deviceId: deviceId,Authorization: token ? "bearer " + token : ""};
    ApiService.post(APIURL.SEND_OTP, params, header)
      .then(res => {
        resolve(res.data);
        console.log("res send otp", res);
      }).catch(err => { reject(err); });
  });
};
export const validateOtpApplyNow = async params => {
  let deviceId = await AsyncStorageFunc.getData('deviceId');
  return new Promise((resolve, reject) => {
    const header = {deviceModel: "",appVersion: "", platform: "", network: "", deviceId: deviceId};
    ApiService.postwithtoken(
      APIURL.VALIDATE_OTP_APPLYNOW,
      params,
      undefined,
      header
    )
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err);});
  });
};
export const getEncryptKey = async params => {
  let deviceId = await AsyncStorageFunc.getData('deviceId');
  return new Promise((resolve, reject) => {
    const header = { deviceModel: "", appVersion: "",platform: "",network: "", deviceId: deviceId };
    ApiService.get(APIURL.GET_ENC_KEY, params, header)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err);});
  });
};
export const getPaymentData = async params => {
  let deviceId = await AsyncStorageFunc.getData('deviceId');
  console.log(JSON.stringify(deviceId), "device id getPaymentData")
  return new Promise((resolve, reject) => {
    const header = { deviceModel: "", appVersion: "", platform: "", network: "", deviceId: deviceId};
    ApiService.postwithtoken(APIURL.GET_PAYMENT_DATA, params)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err);});
  });
};

export const logout = params => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.LOGOUT, params)
      .then(res => {
        AsyncStorageFunc.deleteData("TOKEN").then(tokenRes => {
          resolve(res);
        });
      }).catch(err => { reject(err); });
  });
};
export const getAllVehiclesList = () => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_ALL_VEHICLES_FOR_USER)
      .then(res => {
        resolve(res?.data || []);
      }).catch(err => { reject(err);});
  });
};
export const getAllVehiclesListV2 = () => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_ALL_VEHICLES_FOR_USER_V2)
      .then(res => {
        resolve(res?.data || []);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const getAllNpciClosedVehicles = () => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_ALL_VEHICLES_FOR_NPCI_CLOSED)
      .then(res => {
        resolve(res?.data || []);
      }).catch(err => { reject(err);});
  });
};
export const getAllKyvPendingVehicles = () => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_ALL_VEHICLES_FOR_KYV_PENDING)
      .then(res => {
        resolve(res?.data || []);
      }).catch(err => { reject(err);});
  });
};
export const filterVehicle = async (params) => {
  let deviceId = await AsyncStorageFunc.getData('deviceId');
  let token = await AsyncStorageFunc.getData("TOKEN");
  const header = {deviceModel: "",appVersion: "",platform: "",network: "",Authorization: token ? "bearer " + token : "", deviceId: deviceId};
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.SEARCH_VEHICLE, params, undefined, header)
      .then(res => {
        resolve(res.data);
      }).catch(err => { reject(err); });
  });
}
export const getPoolAccountdetail = params => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_POOL_ACCOUNT_DETAILS)
      .then(res => {
        resolve(res.response);
      }).catch(err => {reject(err);});
  });
}
export const autoPayEnable = params => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_ENABLE_AUTOPAY_POOL_ACCOUNT)
      .then(res => {
        console.log("res pool", res);
        resolve(res);
      }).catch(err => { reject(err);});
  });
}

export const autoPayDisable = params => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_DISABLE_AUTOPAY_POOL_ACCOUNT)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err);});
  });
}
export const getUserProfileImage = params => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_PROFILE_IMAGE, params, undefined)
      .then(res => {
        resolve(res.data);
      }).catch(err => { reject(err);});
  });
}
export const getUserDetails = params => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_PROFILE_DETAILS)
      .then(res => {
        resolve(res.data);
      }).catch(err => { reject(err);});
  });
}
export const uploadUserImage = params => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.UPDATE_PROFILE_IMAGE, params, undefined)
      .then(res => {
        resolve(res.data);
      }).catch(err => { reject(err);});
  });
}

export const validateOtpWithToken = params => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.VALIDATE_OTP_APPLYNOW, params)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err); });
  });
};
export const getPoolToTagTransfer = params => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.GET_POOL_TO_TAG, params)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err);});
  });
}

export const getAllVehiclesListApi = () => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_ALL_VEHICLES_FOR_USER)
      .then(res => {
        resolve(res?.data || []);
      }).catch(err => { reject(err); });
  });
};
export const getStatementsByVrn = async (params) => {
  let token = await AsyncStorageFunc.getData('TOKEN');
  let deviceId = await AsyncStorageFunc.getData('deviceId');
  const header = { deviceModel: "", appVersion: "", platform: "", network: "",Authorization: token ? "bearer " + token : "", deviceId: deviceId};
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.STATEMENT_BY_VRN, params, undefined, header)
      .then(res => {
        resolve(res?.data || []);
      }).catch(err => { reject(err); });
  });
};

export const getTagToPoolTransfer = params => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.GET_TAG_TO_POOL, params)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err);});
  });
}
export const getTagToTagTransferReq = params => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.POST_TAG_TO_TAG_REQ, params)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err); });
  });
}

export const getTagToTagTransferProc = params => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.POST_TAG_TO_TAG_PROC, params)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err); });
  });
}

export const getAddress = params => {
  return new Promise((resolve, reject) => {
    const header = { deviceModel: "", appVersion: "", platform: "", network: "", 
    // "Access-Control-Allow-Origin": "*"
  };
    axios.get("https://api.postalpincode.in/pincode/" + params)
      .then(res => {
        resolve(res.data);
      }).catch(err => { reject(err);});
  });
}

export const UploadKYCDoc = params => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.VERIFY_SERVICE, params)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err); });
  });
};

export const changeAddress = params => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.CHANGE_ADDRESS, params)
      .then(res => {
        resolve(res);
      }).catch(err => {  reject(err); });
  });
};

export const getCreditCardDetails = () => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.CERDIT_CARD_DETAILS)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err); });
  });
};
export const getAutoRechargeDtls = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.AUTO_RECHARGE_DETAILS, params)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err);});
  });
}
export const updateAutoRechargeStatus = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.UPDATE_AUTO_RECHARGE_STATUS, params)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err);});
  });
}
export const getCpatcha = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.get(APIURL.CAPTCHA, params)
      .then(res => {
        resolve(res);
      }).catch(err => {  reject(err); });
  });
}
export const getKycStatus = params => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_KYC_STATUS)
      .then((res) => {
        resolve(res);
      }).catch((err) => { reject(err);});
  });
};

export const getTermsAndCondition = async (params) => {
  let token = await AsyncStorageFunc.getData('TOKEN');
  let deviceId = await AsyncStorageFunc.getData('deviceId');
  const header = { deviceModel: "", appVersion: "", platform: "", network: "", Authorization: token ? "bearer " + token : "", deviceId: deviceId, e_platform: "web"};
  return new Promise((resolve, reject) => {
    ApiService.get(APIURL.TNC,params, header)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err);});
  });
};
export const  getTermsAndCondition_V1 = async (params) => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.TNC_V1, params).then((res) => {
      resolve(res?.data || []);
    }).catch((err) => { reject(err);});
  });
};

export const updateKyc = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.UPDATE_KYC, params)
      .then((res) => {
        resolve(res);
      }).catch((err) => { reject(err); });
  });
};

export const  getUserConfigAtHome = async (params) => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.SHOW_CONFIG_TO_USER, params).then((res) => {
      resolve(res?.data || []);
    }).catch((err) => { reject(err);});
  });
};
export const raiseDispute = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.RAISE_DISPUTE, params)
      .then((res) => {
        resolve(res);
      }).catch((err) => { reject(err); });
  });
};
export const disputeDropdown = () => {
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.DISPUTE_DROPDOWN)
      .then((res) => {
        resolve(res?.data || []);
      }).catch((err) => { reject(err); });
  });
};
export const disputeCount = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.DISPUTE_COUNT, params)
      .then((res) => {
        resolve(res?.data || []);
      }).catch((err) => {   reject(err);});
  });
};
export const disputeList = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.DISPUTE_LIST,params)
      .then((res) => {
        resolve(res?.data || []);
      }).catch((err) => { reject(err);});
  });
};
export const disputeStatement = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.DISPUTE_STATEMENT,params)
      .then((res) => {
        resolve(res?.data || []);
      }).catch((err) => { reject(err);});
  });
};
export const disputeHistory = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.DISPUTE_HISTORY, params)
      .then((res) => {
        resolve(res?.data || []);
      }).catch((err) => { reject(err); });
  });
};
export const disputeByTxnNo = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.DISPUTE_BY_TXN_NO, params)
      .then((res) => {
        resolve(res?.data || []);
      }).catch((err) => {  reject(err);});
  });
};

export const disputeFilter = (params) => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.DISPUTE_FILTER, params)
      .then((res) => {
        resolve(res?.data || []);
      }).catch((err) => {  reject(err); });
  });
};
export const duplicateDisute = async (params) => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.FILTERED_DISPUTE, params)
      .then(res => {
        resolve(res);
      }).catch(err => {  reject(err); });
  });
}
export const tagClosureFilter = async (params) => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.TAG_CLOSURE_FILTER_VRN, params)
      .then(res => {
        resolve(res);
      }).catch(err => {  reject(err); });
  });
}



